module.exports = __webpack_public_path__ + "static/media/abb_bg_1920w.36e52037.png";